import { render } from "./FaceMoveModal.vue?vue&type=template&id=1c5bae15&scoped=true&ts=true"
import script from "./FaceMoveModal.vue?vue&type=script&lang=ts"
export * from "./FaceMoveModal.vue?vue&type=script&lang=ts"

import "./FaceMoveModal.vue?vue&type=style&index=0&id=1c5bae15&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c5bae15"]])

export default __exports__